/* WildBoard lead capture: mirrors wholesale + contact form submissions into Klaviyo.
   Does not block or alter the normal Shopify form post. */
(function () {
  var PUB = "Szg4iA";
  var REV = "2024-10-15";
  var LIST_WHOLESALE = "WKR2Lk"; /* Wholesale Leads */
  var LIST_EMAIL = "Y9zXDT";     /* Email List */

  function post(path, body) {
    try {
      fetch("https://a.klaviyo.com/client/" + path + "/?company_id=" + PUB, {
        method: "POST",
        keepalive: true,
        headers: { "revision": REV, "Content-Type": "application/json" },
        body: JSON.stringify(body)
      }).catch(function () {});
    } catch (e) {}
  }

  function subscribe(email, listId, source, props) {
    if (!email) return;
    post("subscriptions", {
      data: {
        type: "subscription",
        attributes: {
          custom_source: source || "Website form",
          profile: { data: { type: "profile", attributes: { email: email, properties: props || {} } } }
        },
        relationships: { list: { data: { type: "list", id: listId } } }
      }
    });
  }

  function track(email, metric, props) {
    if (!email) return;
    post("events", {
      data: {
        type: "event",
        attributes: {
          properties: props || {},
          metric: { data: { type: "metric", attributes: { name: metric } } },
          profile: { data: { type: "profile", attributes: { email: email } } }
        }
      }
    });
  }

  function field(form, res) {
    var els = form.querySelectorAll("input, textarea, select");
    for (var i = 0; i < els.length; i++) {
      var n = (els[i].getAttribute("name") || "").toLowerCase();
      for (var j = 0; j < res.length; j++) { if (res[j].test(n)) return els[i]; }
    }
    return null;
  }
  function val(form, res) { var e = field(form, res); return e ? (e.value || "").trim() : ""; }

  function attach(form) {
    var action = form.getAttribute("action") || "";
    form.addEventListener("submit", function () {
      try {
        var email = val(form, [/email/]);
        if (!email) return;
        if (action.indexOf("wbws-") > -1) {
          var store = val(form, [/store/, /company/]);
          var msg = val(form, [/body/, /message/, /comment/]);
          var isReserve = action.indexOf("wbws-reserve") > -1;
          var which = isReserve ? "Reserve" : "Note";
          /* Each wholesale form owns exactly one list. Reserve is owned by the
             Wholesale Waitlist (wb-klaviyo.js subscribes it to VNiWL9), so only the
             "Send us a note" form feeds Wholesale Leads here. This prevents a single
             Reserve submission from landing on two lists and firing two flows. (Amy, 07.29.2026) */
          if (!isReserve) {
            subscribe(email, LIST_WHOLESALE, "Website Wholesale Form", { "Wholesale Store": store });
          }
          track(email, "Submitted Wholesale Inquiry", { "Store": store, "Message": msg, "Form": which, "Source": "Website wholesale page" });
        } else if (action.indexOf("wbct-contact") > -1) {
          var name = val(form, [/\[name\]/, /contactname/]);
          var topic = val(form, [/topic/]);
          var body = val(form, [/body/, /message/, /comment/]);
          track(email, "Submitted Contact Inquiry", { "Name": name, "Topic": topic, "Message": body, "Source": "Website contact page" });
          var nl = field(form, [/newsletter/, /accepts_marketing/, /subscribe/]);
          if (nl && nl.type === "checkbox" && nl.checked) {
            subscribe(email, LIST_EMAIL, "Website Contact Form (opted in)", {});
          }
        }
      } catch (e) {}
    }, { capture: true });
  }

  function init() {
    var forms = document.querySelectorAll('form[action*="/contact"]');
    for (var i = 0; i < forms.length; i++) {
      var a = forms[i].getAttribute("action") || "";
      if (a.indexOf("wbws-") > -1 || a.indexOf("wbct-contact") > -1) attach(forms[i]);
    }
  }

  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); } else { init(); }
})();
